import { useMutation } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function useChangePasswordMutation(closeModal) {
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.CHANGE_PASSWORD_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        SuccessToast({ text: data?.message });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
